// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"637":"order","976":"tool"}[chunkId] + "." + {"637":"42358519","976":"2642de86"}[chunkId] + ".css";
};